import http from 'http';
import { OptionTypeBase } from 'components/forms/BzSelect';
import i18n from 'i18n';
import _ from 'lodash';

export interface HttpStatusCodeItem extends OptionTypeBase {
  statusCode: number;
  statusMsg: string;
}

export const httpStatusCodes: HttpStatusCodeItem[] = [];

for (const key in http.STATUS_CODES) {
  httpStatusCodes.push({
    label: key + ' - ' + http.STATUS_CODES[key],
    statusCode: parseInt(key),
    statusMsg: '' + http.STATUS_CODES[key],
    value: key,
  });
}

export const getStatusCodeItemByCode = (code: number): HttpStatusCodeItem => {
  return _.find(httpStatusCodes, item => item.statusCode === code);
};

export const httpStatusCodesGrouped = [
  {
    label: i18n.t('httpCodes.1xxHeader'),
    options: httpStatusCodes.filter(code => code.value.startsWith('1')),
  },
  {
    label: i18n.t('httpCodes.2xxHeader'),
    options: httpStatusCodes.filter(code => code.value.startsWith('2')),
  },
  {
    label: i18n.t('httpCodes.3xxHeader'),
    options: httpStatusCodes.filter(code => code.value.startsWith('3')),
  },
  {
    label: i18n.t('httpCodes.4xxHeader'),
    options: httpStatusCodes.filter(code => code.value.startsWith('4')),
  },
  {
    label: i18n.t('httpCodes.5xxHeader'),
    options: httpStatusCodes.filter(code => code.value.startsWith('5')),
  },
];

export default httpStatusCodes;
